import Button from 'components/Button';
import Popup from 'components/Popup';
import usePopup from 'hooks/usePopup';
import React from 'react';
import { useTranslation } from 'react-i18next';

type PopupProps = ReturnType<typeof usePopup<HTMLDivElement>>['popupProps'];

interface Props extends PopupProps {
  isLoading?: boolean;
  onConfirm?: () => void;
}

const DeleteRegistrationPopup = React.forwardRef<HTMLDivElement, Props>(({
  isLoading = false,
  onConfirm,
  ...props
}, ref) => {
  const { t } = useTranslation();
  return (
    <Popup
      {...props}
      ref={ref}
      title={t('pages.daily_registration.confirm_delete.title')}
      closeButtonText={t('pages.daily_registration.confirm_delete.buttons.cancel')}
      // eslint-disable-next-line react/no-unstable-nested-components
      cta={() => (
        <Button
          warning
          buttonState={isLoading && 'disabled'}
          onClick={() => {
            onConfirm?.();
          }}
        >
          {t('pages.daily_registration.confirm_delete.buttons.confirm')}
        </Button>
      )}
    >
      <p>
        {t('pages.daily_registration.confirm_delete.content')}
      </p>
    </Popup>
  );
});

export default DeleteRegistrationPopup;
